import React, { Component } from "react";
import All from "./Projects/All";
import Web from "./Projects/Web";
import App from "./Projects/App";
import Design from "./Projects/Design";
import Thumbnail from "./Projects/Thumbnail";

export default class Projects extends Component {
  constructor() {
    super();
    this.state = {
      all: true,
      web: false,
      app: false,
      design: false,
      thumbnail: false,
    };
  }
  render() {
    return (
      <section className="projects_container" id="projects">
        <div className="container">
          <h1 className="project_heading d-flex align-items-center">
            <span className="project-divider"></span> &nbsp; Projects
          </h1>
          <div className="project_container">
            <div className="d-flex">
              <button
                className="btn tab"
                ref={(e) => (this.all = e)}
                onClick={(e) => {
                  this.setState({
                    all: true,
                    web: false,
                    app: false,
                    design: false,
                    thumbnail: false,
                  });
                  this.all.classList.add("tab");
                  this.web.classList.remove("tab");
                  this.app.classList.remove("tab");
                  this.design.classList.remove("tab");
                  this.thumbnail.classList.remove("tab");
                }}
              >
                All
              </button>
              <button
                className="btn"
                ref={(e) => (this.web = e)}
                onClick={() => {
                  this.setState({
                    all: false,
                    web: true,
                    app: false,
                    design: false,
                    thumbnail: false,
                  });
                  this.all.classList.remove("tab");
                  this.web.classList.add("tab");
                  this.app.classList.remove("tab");
                  this.design.classList.remove("tab");
                  this.thumbnail.classList.remove("tab");
                }}
              >
                Web
              </button>
              <button
                className="btn"
                ref={(e) => (this.app = e)}
                onClick={() => {
                  this.setState({
                    all: false,
                    web: false,
                    app: true,
                    design: false,
                    thumbnail: false,
                  });
                  this.all.classList.remove("tab");
                  this.web.classList.remove("tab");
                  this.app.classList.add("tab");
                  this.design.classList.remove("tab");
                  this.thumbnail.classList.remove("tab");
                }}
              >
                App
              </button>
              <button
                className="btn"
                ref={(e) => (this.design = e)}
                onClick={() => {
                  this.setState({
                    all: false,
                    web: false,
                    app: false,
                    design: true,
                    thumbnail: false,
                  });
                  this.all.classList.remove("tab");
                  this.web.classList.remove("tab");
                  this.app.classList.remove("tab");
                  this.design.classList.add("tab");
                  this.thumbnail.classList.remove("tab");
                }}
              >
                Designs
              </button>
              <button
                className="btn"
                ref={(e) => (this.thumbnail = e)}
                onClick={() => {
                  this.setState({
                    all: false,
                    web: false,
                    app: false,
                    design: false,
                    thumbnail: true,
                  });
                  this.all.classList.remove("tab");
                  this.web.classList.remove("tab");
                  this.app.classList.remove("tab");
                  this.design.classList.remove("tab");
                  this.thumbnail.classList.add("tab");
                }}
              >
                Gaming Thumbnail
              </button>
            </div>
            <div className="projects_display mt-5">
              {this.state.all && <All />}
              {this.state.web && <Web />}
              {this.state.app && <App />}
              {this.state.design && <Design />}
              {this.state.thumbnail && <Thumbnail />}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
